import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=47537cb9&"
import script from "./EmployeeCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports